import { render } from "./MultipleCheckboxWithText.vue?vue&type=template&id=07987f43"
import script from "./MultipleCheckboxWithText.vue?vue&type=script&lang=js"
export * from "./MultipleCheckboxWithText.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Questionnaire/Question/MultipleCheckboxWithText.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "07987f43"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('07987f43', __exports__)) {
    api.reload('07987f43', __exports__)
  }
  
  module.hot.accept("./MultipleCheckboxWithText.vue?vue&type=template&id=07987f43", () => {
    api.rerender('07987f43', render)
  })

}


export default __exports__